import './Login.css';
import logo from '../../assets/images/logo.svg';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { login } from '../../service/authService';
import loaderService from '../../service/loaderService';
import { axiosInstance } from '../../config/axiosConfig';
import { LOGIN } from "../../config/endpoint";
import { showError } from "../../service/toastService";

const schema = yup.object().shape({
  email: yup.string().email('Invalid email address').required('Email is required'),
  password: yup.string().required('Password is required'),
});

const Login = () => {
  const [isShowPassword, setIsShowPassword] = useState(false)
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const res = await loginUser(data);

  };

  const loginUser = async (formData) => {
    loaderService.show();
    axiosInstance.post(LOGIN, formData)
      .then(res => {
        localStorage.setItem('userInfo', JSON.stringify(res.user || {}))
        localStorage.setItem('token', res.token)
        if (res.user.IsActive) {
          navigate('/new-user')
        } else {
          navigate('/onboarding');
        }

      })
      .catch(err => {
        showError(err?.response?.data?.message)
      }).finally(() => {
        loaderService.hide();
      });
  }

  return (
    <div className='login'>
      <div className='py-32'>
        <img src={logo} alt="logo" />
      </div>
      <div className='login_form_container'>
        <div className='login_form'>
          <div className='heading'>Sign In to <b>brainyagent.ai</b></div>
          <form className='w-100 gap-16 d-flex flex-column' autoComplete='off' onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className='input-container'>
                <label> Work Email Address </label>
                <input type="text" className='input' autoComplete="new-password" {...register('email')} />
              </div>
              {errors.email && (
                <p className='error-message' style={{ color: 'red', marginTop: 4 }}>
                  {errors.email.message}
                </p>
              )}
            </div>
            <div>
              <div className='input-container'>
                <label> Password </label>
                <input type={isShowPassword ? 'text' : 'password'} className='input' {...register('password')} autoComplete="new-password" />
                <div className='icon'>
                  {isShowPassword ?
                    <MdOutlineVisibilityOff size={22} color='#C3C6CF' onClick={() => setIsShowPassword(false)} /> :
                    <MdOutlineVisibility size={22} color='#C3C6CF' onClick={() => setIsShowPassword(true)} />
                  }
                </div>
              </div>
              {errors.password && (
                <p className='error-message' style={{ color: 'red', marginTop: 4 }}>
                  {errors.password.message}
                </p>
              )}
            </div>
            <div className='color-white d-flex align-items-center gap-8'>
              <div className='p-12 d-flex'><input type="checkbox" className="custom-checkbox" /></div><span>Remember me</span>
            </div>

            <button className='theme-sky-btn'>Log In</button>
            <p className='color-white fw-light text-center'>New here? <span className='text-decoration-underline cursor-pointer' onClick={() => navigate('/signup')}>Create an Account</span></p>
            <div className='d-flex justify-content-between'>
              <p className='color-white fw-light text-center cursor-pointer text-decoration-underline' onClick={() => navigate('/forgot-password', { state: { email: watch('email') } })}>Forgot Password?</p>
              <p className='color-white fw-light text-center cursor-pointer text-decoration-underline' onClick={() => navigate('/account-recover', { state: { email: watch('email') } })}>Account Recover?</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
